import sharedLogoCarousel from './shared-logo-carousel';

export default function minimalLogoCarousel(root: HTMLElement): void {
  sharedLogoCarousel(root, {
    cloneAttribute: 'data-minimal-logo-carousel-clone',
    desktopSpeedPxPerSecond: 66,
    durationProperty: '--minimal-logo-carousel-duration-current',
    hoverPauseAttribute: 'data-minimal-logo-carousel-hover-pause',
    imageSelector: '.minimal-logo-carousel__image',
    loopDistanceProperty: '--minimal-logo-carousel-loop-distance',
    mobileSpeedPxPerSecond: 66,
    readyAttribute: 'data-minimal-logo-carousel-ready',
    setSelector: '.minimal-logo-carousel__set',
    trackSelector: '.minimal-logo-carousel__track',
    viewportSelector: '.minimal-logo-carousel__viewport'
  });
}
